import { tenants } from "./tenants";
import type { TenantConfig, TenantDefinition, TenantFeatures } from "./types";

const featureDefaults: TenantFeatures = {};

/** Merge defaults + tenant overrides into a fully-resolved `TenantConfig`. */
export function resolveConfig(def: TenantDefinition): TenantConfig {
	return {
		id: def.id,
		name: def.name,
		theme: def.theme,
		branding: def.branding,
		features: { ...featureDefaults, ...def.features },
		defaultLocale: def.defaultLocale,
		login: def.login,
	};
}

/** Resolve a tenant by slug, falling back to the `default` tenant. */
export function resolveTenant(tenantId: string): TenantConfig {
	const def = tenants[tenantId] ?? tenants.default;
	return resolveConfig(def);
}
